import { gql } from '@apollo/client';
import { CONTACT_LABEL_PREVIEW_FIELDS } from 'src/components/pages/dashboard/components/cards/shared/helpers';
import { CORE_PAGE_INFO_FIELDS } from 'src/components/providers/apollo-provider-provider';

export const AI_AGENT_SESSIONS_QUERY = gql`
  ${CORE_PAGE_INFO_FIELDS}
  ${CONTACT_LABEL_PREVIEW_FIELDS}
  query AIAgentSessions(
    $companyId: Int!
    $aiAgentId: ID!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $orderBy: AIAgentSessionOrderByInput
    $where: AIAgentSessionWhereInput
  ) {
    aiAgents {
      getAIAgent(input: { companyId: $companyId, id: $aiAgentId }) {
        id
        sessions(
          after: $after
          before: $before
          first: $first
          last: $last
          orderBy: $orderBy
          where: $where
        ) {
          totalCount
          pageInfo {
            ...PageInfoFragment
          }
          nodes {
            id
            type
            status
            goalStatus
            createdAt
            durationInSeconds
            contact {
              ...ContactLabelPreviewFields
              lastConversation {
                id
              }
            }
          }
        }
      }
    }
  }
`;

export const AI_AGENT_SESSION_OVERVIEW_QUERY = gql`
  query AIAgentSessionOverview($input: AIAgentSessionInput!) {
    aiAgents {
      getAIAgentSession(input: $input) {
        id
        type
        status
        summary
        aiAgent {
          id
          name
          friendlyName
        }
        goals {
          id
          name
          status
        }
        toolCalls {
          id
          name
        }
        takenOverBy {
          id
          fullName
          role {
            id
            name
          }
          avatar {
            color
            initials
            url(transform: { width: 180, height: 180 })
          }
        }
        contactInteraction {
          id
          recording {
            url
          }
          callDetail {
            sentimentAnalysis {
              ... on ContactInteractionSentimentAnalysis {
                id
                phrases {
                  id
                  emotions
                  end
                  phrase
                  sentiment
                  speakerType
                  start
                }
                totalNegatives
                totalPositives
              }
              ... on AsyncStatusPending {
                asyncStatus
              }
              ... on SentimentAnalysisDisabled {
                asyncStatus
              }
            }
            transcription {
              ... on ContactInteractionTranscription {
                id
                phrases {
                  edges {
                    cursor
                    node {
                      id
                      emotions
                      end
                      phrase
                      sentiment
                      speakerType
                      start
                    }
                  }
                }
                contact {
                  id
                  label
                  status {
                    id
                    name
                  }
                  stage {
                    id
                    slug
                  }
                }
                user {
                  id
                  fullName
                  avatar {
                    color
                    initials
                  }
                }
              }
              ... on AsyncStatusPending {
                asyncStatus
              }
              ... on ContactInteractionTranscriptionDisabled {
                asyncStatus
              }
            }
          }
        }
      }
    }
  }
`;
